import { GetterTree } from "vuex";
import { ILogsState } from "@/store/modules/logs/state";
import { ILog } from "@/store/modules/logs/state";
import { IDataProvider, IRootState } from "@/store";

export enum LogsGetters {
  GET_ALL = "GET_ALL_LOG",
  GET_CURRENT = "GET_CURRENT_LOG",
  GET_DATA_PROVIDER = "GET_DATA_PROVIDER_LOG",
}

export const getters: GetterTree<ILogsState, IRootState> = {
  [LogsGetters.GET_ALL](state): ILog[] | null {
    return state.logs;
  },
  [LogsGetters.GET_CURRENT](state): ILog | null {
    return state.log;
  },
  [LogsGetters.GET_DATA_PROVIDER](state): IDataProvider<ILog> | null {
    return state.dataProvider;
  },
};
